import { createContext } from 'react';
import qs from 'query-string';
import { isBrowser } from '../utils';
import { getGlobalThis } from '../ssr-window';
import { getClientIp } from '../store';
const ContextKey = Symbol.for(`cap-ssr-app-context`);
const RequestContextKey = Symbol.for('client-request-context');
const globalThat = getGlobalThis();
/**
 * 浏览器端，创建请求上下文对象
 * @returns
 */
export function createRequestContext() {
    var _a, _b;
    // eslint-disable-next-line no-multi-assign
    const contextMap = ((_a = globalThat[RequestContextKey]) !== null && _a !== void 0 ? _a : (globalThat[RequestContextKey] = new Map()));
    let realContext = contextMap.get(createRequestContext);
    if (!realContext) {
        const { href, pathname, origin, protocol, host, hostname, search } = window.location;
        const query = (_b = qs.parseUrl(href)) === null || _b === void 0 ? void 0 : _b.query;
        const body = {};
        realContext = window.__CTX_DATA__;
        const clientIp = getClientIp();
        realContext = realContext || {
            query,
            body,
            path: pathname,
            url: `${pathname}${search}`,
            href,
            origin,
            method: 'GET',
            protocol,
            host,
            hostname,
            /**
             * 用户ip, 如果是部署在webstatic上，可以通过 $.context.c-first-public-ip 获取并设置在cookie中
             */
            ip: clientIp,
            // 与ip字段值相同
            clientIp,
            header: {
                'user-agent': navigator.userAgent,
                cookie: document.cookie,
            },
        };
        contextMap.set(createRequestContext, realContext);
    }
    return realContext;
}
/**
 * 获取AppContext
 * @returns
 */
function getAppContext() {
    var _a;
    // eslint-disable-next-line no-multi-assign
    const contextMap = ((_a = globalThat[ContextKey]) !== null && _a !== void 0 ? _a : (globalThat[ContextKey] = new Map()));
    let realContext = contextMap.get(createContext);
    if (!realContext) {
        realContext = createContext({
            state: {},
            ctx: isBrowser ? createRequestContext() : {},
        });
        if (process.env.NODE_ENV !== 'production') {
            realContext.displayName = 'CapSSRAppContext';
        }
        contextMap.set(createContext, realContext);
    }
    return realContext;
}
export const App_Context = getAppContext();
